import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CompletionCard = ({ onGoToDashboard, sampleTasksImported }) => {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="bg-card rounded-2xl border-2 border-border shadow-soft-xl p-6 md:p-8 lg:p-10 text-center">
        {/* Success Icon */}
        <div className="w-24 h-24 md:w-28 md:h-28 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-6 animate-bounce-slow">
          <Icon name="CheckCircle" size={48} color="var(--color-success)" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
          Tour Complete! 🎉
        </h1>
        <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
          You're all set to start managing your tasks with the Eisenhower Matrix.
          {sampleTasksImported
            ? 'Your sample tasks are ready to explore!' :' Start by creating your first task.'}
        </p>

        {/* Key Takeaways */}
        <div className="bg-background rounded-xl border border-border p-6 mb-8 text-left">
          <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
            Key Takeaways
          </h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground">
                <strong>Do First:</strong> Focus on urgent and important tasks immediately
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground">
                <strong>Schedule:</strong> Plan time for important but not urgent tasks
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground">
                <strong>Delegate:</strong> Consider delegating urgent but not important tasks
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground">
                <strong>Eliminate:</strong> Minimize or remove tasks that aren't urgent or important
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <Button
          variant="default"
          size="lg"
          onClick={onGoToDashboard}
          iconName="ArrowRight"
          iconPosition="right"
          className="w-full sm:w-auto"
        >
          Go to Dashboard
        </Button>

        {/* Additional Help */}
        <div className="mt-8 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Need help? You can restart the tour anytime from{' '}
            <span className="text-primary font-medium">Settings → Help & Support</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompletionCard;